import { Input } from "reactstrap";

function TextInput(props: any) {

	const {
		id,
		name,
		value,
		type,
		className,
		placeholder,
		validate = (value: string) => !(value && value.length),
		onChange,
		...rest
	}: {
		id: any,
		name: string,
		value: string,
		type: 'text' | 'tel' | 'password',
		className: any,
		placeholder?: string
		validate?: Function,
		onChange: Function,
	} = props

	const handleChange = (e: any) => {
		const error = validate(e.target.value)
		return onChange(e, error);
	};

	return (
		<Input
			type={type}
			name={name}
			placeholder={placeholder}
			value={value}
			onChange={handleChange}
			{...rest}
		/>
	)
}

export default TextInput;
